import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Button } from 'primereact/button';

const ListadoPreciosConfirmacion = ({productosPresupuesto, handlePercentageChange, formatearMoneda, clienteSeleccionado }) => {
    const [globalFilter, setGlobalFilter] = useState(null);

    return (
        <>
        <DataTable value={productosPresupuesto}>
            <Column alignHeader={"center"} field="codigo" header="Codigo" style={{ textAlign: "center", fontSize:"15px" }}
            headerClassName='header-table-style' />
            <Column alignHeader={"center"} field="nombre" header="Nombre" style={{ textAlign: "center", fontSize:"15px" }}
            headerClassName='header-table-style' />
            <Column alignHeader={"center"} 
                field="precio_producto" 
                header="Precio Original" 
                body={(rowData) => formatearMoneda(rowData.precio_producto)} 
                style={{ textAlign: "center", fontSize:"15px" }}
                headerClassName='header-table-style' 
            />
            <Column alignHeader={"center"} 
                field="porcentaje" 
                header="Aplicar Descuento (%)" 
                body={(rowData) => (
                    <InputNumber 
                        value={rowData.porcentajeModificado || 0} 
                        onChange={(e) => handlePercentageChange(e, rowData)} 
                        onVal
                        mode="decimal" 
                        inputStyle={{ textAlign:"center" }}
                    />
                )} 
                style={{ textAlign: "center", fontSize:"15px" }}
                headerClassName='header-table-style' 
            />
            <Column alignHeader={"center"} 
                field="nuevoPrecio" 
                header="Nuevo Precio" 
                body={(rowData) => formatearMoneda(rowData.nuevoPrecio)} 
                style={{ textAlign: "center", fontSize:"15px" }}
                headerClassName='header-table-style' 
            />
            <Column alignHeader={"center"} 
                field="total" 
                header="Total" 
                body={(rowData) => formatearMoneda(rowData.nuevoPrecio)} 
                style={{ textAlign: "center", fontSize:"15px" }}
                headerClassName='header-table-style' 
            />
        </DataTable>
    </>
    );
};

export default ListadoPreciosConfirmacion;
